import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { ValidationResult } from "features/common/models/ValidationResult";
import { UpdateRequisitoRequest } from "features/projetos/pages/ProjetoEditPage/tabs/Requisitos/RequisitosOffCanvas";

export async function updateRequisito(data: UpdateRequisitoRequest): Promise<IResponse<ValidationResult>> {
    return await axios.put(`/Requisito/Update`, data);
}
